<template>
  <div class="text-center">
    <div v-bind:class="class_name()" style="width: 100%; margin-top: 5px">
      <div
        v-bind:data-percentage="val + '%'"
        v-bind:style="'width: ' + val + '%'"
        v-bind:class="class_bar()"
      ></div>
    </div>
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bar: "success",
    };
  },
  props: {
    type: {
      type: String,
      default: "success",
    },
    size: String,
    val: [String, Number],
    label: [String, Number],
  },

  methods: {
    class_name() {
      var self = this;
      var class_name = "";
      if (self.size == undefined) {
        class_name = "progress";
      } else {
        class_name = "progress progress-" + self.size;
      }
      return class_name;
    },
    class_bar() {
      var self = this;

      if (self.type) {
        return "progress-bar progress-bar-" + self.type;
      }

      var val = self.val * 1;
      if (val < 20) {
        self.bar = "success";
      } else if (val > 20 && val < 80) {
        self.bar = "primary";
      } else if (val > 80) {
        self.bar = "danger";
      }
      return "progress-bar progress-bar-" + self.bar;
    },
  },
  mounted() {},
};
</script>

<style scoped>
</style>
